"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../../GatewayService.js"));

var _log = _interopRequireDefault(require("../../log.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var feedback = new _GatewayService["default"]('feedbacktwo');

var fetchAllCommentsInCardstack = function fetchAllCommentsInCardstack(userKey, cardstackKey) {
  return feedback.get("comment/".concat(userKey, "/cardstack/").concat(cardstackKey));
};

var deleteComment = function deleteComment(commentKey) {
  return feedback["delete"]("comment/".concat(commentKey));
};

var updateComment = function updateComment(commentKey, commentText) {
  return feedback.put("comment/".concat(commentKey), commentText, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var createComment = function createComment(userKey, unitKey, cardstackKey, commentText, breadcrumb, classKey) {
  var params = {
    userBusinessKey: userKey,
    unitBusinessKey: unitKey,
    cardstackBusinessKey: cardstackKey,
    sectionBusinessKey: classKey
  };
  return feedback.post('comment', {
    commentText: commentText,
    breadcrumb: breadcrumb
  }, {
    params: params
  });
};

var saveAllComments = function saveAllComments(userAndCommentKeys, unitBusinessKey, cardstackBusinessKey, commentText, breadcrumb) {
  var params = userAndCommentKeys.map(function (commentObj) {
    var commentKeyObj = commentObj.commentKey ? {
      commentBusinessKey: commentObj.commentKey
    } : {};
    return Object.assign({}, commentKeyObj, {
      userBusinessKey: commentObj.userKey,
      unitBusinessKey: unitBusinessKey,
      cardstackBusinessKey: cardstackBusinessKey,
      commentText: commentText,
      breadcrumb: breadcrumb
    });
  });
  return feedback.put('bulk/comment', params)["catch"](function (err) {
    _log["default"].warn('Unable to save comments: ', err);

    throw err;
  });
};

var sendComments = function sendComments(userKey, cardstackKey) {
  return fetchAllCommentsInCardstack(userKey, cardstackKey).then(function (allComments) {
    var unsubmittedComments = _lodash["default"].filter(allComments, function (comment) {
      return !comment.submittedDate;
    });

    var unsubmittedCommentKeys = _lodash["default"].map(unsubmittedComments, 'businessKey');

    if (_lodash["default"].isEmpty(unsubmittedCommentKeys)) {
      return Promise.resolve();
    }

    return feedback.post("comment/submit", unsubmittedCommentKeys.join(','));
  });
};

var saveAndSendAllComments = function saveAndSendAllComments(userKey, unitKey, cardstackKey, classKey, commentText, commentKey, breadcrumb) {
  if (commentKey) {
    return updateComment(commentKey, commentText).then(function () {
      return sendComments(userKey, cardstackKey);
    });
  }

  return createComment(userKey, unitKey, cardstackKey, commentText, breadcrumb, classKey).then(function () {
    return sendComments(userKey, cardstackKey);
  });
};

var markCommentAsRead = function markCommentAsRead(commentKey) {
  return feedback.put("comment/".concat(commentKey, "/read"));
};

var markAllCommentsAsRead = function markAllCommentsAsRead(commentKeys) {
  return feedback.post("comment/read", commentKeys.join(','));
};

var _default = {
  fetchAllCommentsInCardstack: fetchAllCommentsInCardstack,
  deleteComment: deleteComment,
  updateComment: updateComment,
  createComment: createComment,
  saveAllComments: saveAllComments,
  sendComments: sendComments,
  saveAndSendAllComments: saveAndSendAllComments,
  markCommentAsRead: markCommentAsRead,
  markAllCommentsAsRead: markAllCommentsAsRead
};
exports["default"] = _default;